const collectionDiscounts = {
// "omnia": 15,                         // 'Omnia15'
// "omnia-leather": 10,                  //'Omnia10'
// "natuzzi-editions-furniture": 10,      // 'NAT10'
// "img": 15,                           // 'IMG20'
// "eleanor-rigby": 5,                // 'ELR5'
// "palliser":12,                     // 'PAL12'
// "american-made": 33,                // 'USA33'
};

discountPercent = 0;

jQuery(document).ready(function(){
  natuzzi = false;
  collection_list.forEach(function(item, index){
    if (collectionDiscounts[item] && collectionDiscounts[item] > discountPercent) {
      discountPercent = collectionDiscounts[item];
    }

    if (item == "natuzzi-editions-furniture" || item == "omnia-leather" || item == "palliser" || item == "img" || item == "eleanor-rigby" || item == "american-made") {
      natuzzi = true;
    }
  })
  
  if (discountPercent > 0) {
    jQuery(".set-product .set-rail .railing .totals .savings-price .custom-discount-percent").addClass('old').html(" (" + discountPercent + "% OFF)");
    if (natuzzi) {
      console.log("Passed !");
      jQuery(".set-product .set-rail .railing .totals .savings-price .custom-discount-percent").removeClass('old').html(discountPercent + "% OFF").addClass('valid');
      setTimeout(function(){
        setDicsountPrice();
        jQuery(".price-wrap .custom-discount-percent").html("SALE " + discountPercent + "% OFF");
        jQuery(".price-wrap").removeClass("hidden");
      }, 100);

      setTimeout(function(){
          jQuery(".custom-product-discount-price").html(new Intl.NumberFormat('en-US', {
                      style: 'currency',
                      currency: 'USD'
                  }).format(jQuery(".custom-product-discount-price").html() / 100 * (100 - discountPercent) / 100)
               ).removeClass("hidden");
        }, 100);
        jQuery(".custom-price-wrap").addClass("discount");
        jQuery(".custom-price-wrap .discount-percent").html(discountPercent);
     }
    } else {
    console.log("no Passed !");
      setTimeout(function(){
          jQuery(".custom-product-discount-price").html(new Intl.NumberFormat('en-US', {
                      style: 'currency',
                      currency: 'USD'
                  }).format(jQuery(".custom-product-discount-price").html() / 100 * (100 - discountPercent) / 100)
               ).removeClass("hidden");
        }, 100);
        jQuery(".custom-price-wrap").addClass("discount");
        jQuery(".custom-price-wrap .discount-percent").html(discountPercent);
    }
})


function setDicsountPrice(){
  console.log("Setting !");
  jQuery(".custom-discount-price").each(function(item, index){
      if (jQuery(this).html() && jQuery.isNumeric(jQuery(this).html())) {
        
        jQuery(this).html(new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(jQuery(this).html() / 100 * (100 - discountPercent) / 100)
             ).removeClass("hidden");
      }
    })
}
